import {
  ISortOption,
  ISortOptionKey,
} from '@/components/Product/SortBy/types';

export const SortOption: {
  [key in ISortOptionKey]: ISortOption;
} = {
  recommended: {
    name: 'Recommended',
    value: 'recommended',
  },
  latest: {
    name: 'Latest',
    value: 'createdAt DESC',
  },
  priceAsc: {
    name: 'Price: Low to high',
    value: 'price ASC',
  },
  priceDesc: {
    name: 'Price: High to low',
    value: 'price DESC',
  },
};
export const sortOptions: ISortOption[] = [
  SortOption.recommended,
  SortOption.latest,
  SortOption.priceAsc,
  SortOption.priceDesc,
];
